import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { ContactInfo } from '../schemas/contact-info.schema';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

/**
 * Update Fleet contact info.
 * @param contactInfo Updated contact info
 * @returns Basic info for updated fleet contact
 *
 * @example
 * FleetsApi.putCompanyContactInfo({
 *  contactName: 'Raj',
 *  contactEmail: 'email@example.com',
 *  contactPhone: '555-555-5555,
 *  numberOfWeeksToSaveData: 157
 * })
 */
export function putCompanyContactInfo(this: unknown, contactInfo: ContactInfo) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(`${fleetEnvironment.resolve(this).companyContactInfoUrl}`, {
        method: 'PUT',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(contactInfo),
      })
    )
  ).pipe(
    selectData(
      z.object({
        message: z.string(),
        data: z.boolean(),
      })
    )
  );
}
